import { createApi } from "./apiFactory";
import { Backend_LOCAL_PROXY, crfUtilsURL, crfUtilsURLToken, crfPlatformAgentsURLToken, ASK_URL, ASK_URL_TOKEN } from "../../constant";


export const api = createApi({
  baseURL: Backend_LOCAL_PROXY,  //process.env.NODE_ENV === "production" ? "https://api-aiwriter-services-poc.otsuka-us.com" : "",
  utilsURL: crfUtilsURL,
  utilsToken: crfUtilsURLToken,
  platformAgentsToken: crfPlatformAgentsURLToken,
  ASK_URL,
  ASK_URL_TOKEN
});
